export const isMediaType = (value: string, type: string) => {
    console.log(value.split(".").at(-1))
    return value.split(".").at(-1) === type
}